import { RAISE_API_V1_URL } from "constants/endpoints";
import { deleteMethod, post } from "services/api";

export const applyCoupon = async ({
  promoCode,
  device,
  payment_method_uuid
}) => {
  const url = `${RAISE_API_V1_URL}/checkout/promo`;
  const body = {
    device,
    payment_method_uuid,
    promo_code: promoCode
  };
  const response = await post(url, body);
  return response.data;
};

export const removeCoupon = async () => {
  const url = `${RAISE_API_V1_URL}/checkout/promo`;
  const response = await deleteMethod(url);
  return response.data;
};
